import { gql } from '@apollo/client';

import type * as GraphQLTypes from '../../graphql/types.generated';
export type UnassignNotifiedPartyMutationVariables = GraphQLTypes.Exact<{
  input: GraphQLTypes.UnassignNotifiedPartyInput;
}>;

export type UnassignNotifiedPartyMutationResult = { __typename?: 'Mutation' } & {
  bookingUnassignNotifiedParty?: GraphQLTypes.Maybe<
    { __typename?: 'UnassignNotifiedPartyPayload' } & {
      errors?: GraphQLTypes.Maybe<Array<{ __typename?: 'Error' } & Pick<GraphQLTypes.Error, 'message' | 'path'>>>;
    }
  >;
};

export const UnassignNotifiedPartyDocument = gql`
  mutation unassignNotifiedParty($input: UnassignNotifiedPartyInput!) {
    bookingUnassignNotifiedParty(input: $input) {
      errors {
        message
        path
      }
    }
  }
`;
